import moment from "moment";

interface Coordinate<T> {
  x: T;
  y: number | null;
  nullify?: boolean;
}
export function accumulateYValues<T = any>(
  input: Coordinate<T>[],
): Coordinate<T>[] {
  // The array to store accumulated values
  const accumulated: Coordinate<T>[] = [];

  // Variable to keep track of the accumulated sum
  let sum = 0;

  // Iterate through each coordinate in the input array
  input.forEach((coordinate) => {
    // Add the current y value to the sum
    sum += coordinate?.y ?? 0;
    // Push the updated sum to the accumulated array
    accumulated.push({
      x: coordinate.x,
      y: coordinate?.nullify ? null : sum,
    });
  });

  return accumulated;
}
